import { GetStaticProps } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'

import { makeMainLayout } from '@/layouts/main'
import ErrorPage from '@/features/ErrorPage'

const NotFound = () => {
  return <ErrorPage type={ErrorPage.Types.NotFound} />
}

export const getStaticProps: GetStaticProps = async ({ locale = '' }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['translation']))
    }
  }
}

const headerConfig = {
  showSearch: true
}

NotFound.Layout = makeMainLayout({ headerConfig })

export default NotFound
